<template>
  <div>
    <div class="swiper-wrapper">
      <swiper
        ref="billSwiper"
        :options="swiperOptionh"
        class="swiper-box"
        @slideChange="billChanged"
      >
        <swiper-slide
          v-for="(item, index) in bills"
          :key="item.denomination + item.series"
          class="swiper-item green"
        >
          <BillListItem
            v-bind="item"
            :feature-slug="index == currentSlide ? feature : null"
            @feature-slug="featureChanged"
          />
        </swiper-slide>
        <div
          slot="button-prev"
          class="swiper-button-prev swiper-button-prev-h swiper-button-white"
        />
        <div
          slot="button-next"
          class="swiper-button-next swiper-button-next-h swiper-button-white"
        />
      </swiper>
    </div>

    <div class="click d-flex flex-column justify-content-between">
      <div class="top d-flex flex-column align-items-center" />
      <div class="left-slider-right d-flex justify-content-between">
        <div class="d-flex align-items-start">
          <a href="" title="previous value">{{ prevBill.denomination }}</a>
        </div>
        <div class="d-flex align-items-end">
          <a href="" title="next value">{{ nextBill.denomination }}</a>
        </div>
      </div>
      <div class="d-flex flex-column align-self-middle" />
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

import BillListItem from './BillListItem.vue';

function findBillIndex(bills, denomination, series) {
  const index = bills.findIndex(i => i.denomination === denomination && i.series === series);
  console.assert(index !== -1);

  return index;
}

export default {
  components: {
    swiper,
    swiperSlide,
    BillListItem,
  },
  props: {
    bills: {
      type: Array,
      required: true,
    },
    denomination: {
      type: Number,
      required: true,
    },
    series: {
      type: String,
      required: true,
    },
    feature: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    const initialSlide = findBillIndex(
      this.bills, this.denomination, this.series,
    );

    return {
      // Swiper parameters
      swiperOptionh: {
        resistanceRatio: 0.95,
        slidesPerView: 1,
        // preventInteractionOnTransition: true,
        preventClicks: false,
        preventClicksPropagation: false,
        longSwipes: false,
        loop: true,
        direction: 'horizontal',
        mousewheel: false,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        // pagination: {
        //   el: '.swiper-pagination-h',
        //   clickable: true
        // },
        navigation: {
          nextEl: '.swiper-button-next-h',
          prevEl: '.swiper-button-prev-h',
        },
        // For some reason, this.currentSlide doesn't work here (yet).
        initialSlide,
      },
    };
  },
  computed: {
    billSwiper() {
      return this.$refs.billSwiper.swiper;
    },
    renderSlides() {
      // Number of slides to render before and after current slide.
      const renderAround = 2;

      return whichToRender(this.currentSlide, this.bills.length, renderAround);
    },
    currentSlide() {
      return findBillIndex(this.bills, this.denomination, this.series);
    },
    nextBill() {
      const index = findBillIndex(this.bills, this.denomination, this.series) + 1;

      // We're at the last, next is first
      if (index > this.bills.length - 1) return this.bills[0];

      return this.bills[index];
    },
    prevBill() {
      const index = findBillIndex(this.bills, this.denomination, this.series) - 1;

      // We're at the first, return last
      if (index < 0) return this.bills[this.bills.length - 1];

      return this.bills[index];
    },
  },
  watch: {
    currentSlide(index, oldIndex) {
      console.log('currentSlide (bill) changed from', oldIndex, 'to', index);

      // Make sure the swiper is in sync with the component
      if (index !== this.billSwiper.realIndex) {
        this.billSwiper.slideToLoop(index);
      }
    },
  },
  methods: {
    billChanged() {
      // Tell our parent the bill has changed
      // Expecting them to update denomination and series props correspondingly
      const index = this.billSwiper.realIndex;

      // Only fire event if the index actually changed
      if (index !== this.currentSlide) {
        const bill = this.bills[index];
        this.$emit('bill', bill.denomination, bill.series);
      }
    },
    featureChanged(feature) {
      // Just bubble up; should be handled on a higher level
      console.log('featureChanged (bill)', feature, this.denomination, this.series);

      this.$emit('feature', feature);
    },
  },
};
</script>

<style scoped lang="scss">
  .swiper-wrapper {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    .swiper-box {
      width: 100%;
      height: 100vh;
      .swiper-button-prev.swiper-button-prev-h {
        background-image: url("~@/assets/placeholders/arrow.svg");
        background-size: auto auto;
        background-position: center;
        left: 0 !important;
        opacity: 0.5;
        &:hover {
          opacity: 1;
        }
      }
      .swiper-button-next.swiper-button-next-h {
        background-image: url("~@/assets/placeholders/arrow.svg");
        background-size: auto auto;
        background-position: center;
        transform: rotate(180deg) !important;
        right: 0 !important;
        opacity: 0.5;
        &:hover {
          opacity: 1;
        }
      }
    }
    .swiper-item {
      text-align: center;
    }
  }

  .swiper-button-next:focus, .swiper-button-prev:focus {
    border: 0;
    outline:0;
  }

  @media only screen and (max-width: 992px) {
    .swiper-button-next, .swiper-button-prev {
      display: none;
    }
  }

  .click {
    height: 100vh;
    position: absolute;
    top: 0; left: 0; bottom: 0; right: 0;
    margin: 0 40px;
    pointer-events: none;
    @media (max-width: 992px) {
      visibility: hidden;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/bill-list/BillList.vue